export default __webpack_public_path__ + "static/media/html.a5836556.svg";